import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Login.css";
import {
	authenticateExternalUser,
	loadActiveUser,
	requestNewPasswordByMail,
} from "../redux/users/usersActions";
import { withRouter } from "react-router-dom";
import logo from "../images/Logo.png";
import Paper from "@material-ui/core/Paper";
import CustomizedTextField from "../components/Input/CustomizedTextField";
import {
	MuiThemeProvider,
} from "@material-ui/core/styles";
import { theme } from './App'
import { AppBar, Button, Dialog, DialogContent, IconButton, TextField, Toolbar, Typography } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/core/styles";
import ReCAPTCHA from "react-google-recaptcha";
import { throwErrorMessage } from "../lib/error_helper";
import { checkEmailFormat } from "../utils";
import { getDefaultSyncState, getSynchroActiveUser } from "../redux/synchro/extranetSynchroActions";

const styles = {
	bgImage: {
		maxWidth: "90%",
		maxHeight: "50%",
		margin: "auto",
		display: "flex",
	},
	appBar: {
		position: 'relative',
		marginBottom: '10px',
	},
	flex: {
		flex: 1,
	},
};

class KeystoneMyOpenLogin extends Component {
	state = {
		login: "",
		password: "",
		forgotPassword: false,
		captchaOk: false
	};

	resize = () => this.forceUpdate();

	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}

	componentDidMount() {
		window.addEventListener("resize", this.resize);
		this.props.loadActiveUser();
	}

	static getDerivedStateFromProps(nextProps) {
		if (nextProps.activeUser !== null) {
			nextProps.loadActiveUser();
			nextProps.history.replace("/");
		}

		return null;
	}

	login(e) {
		if (e)
			e.preventDefault();

		let login = this.state.login;
		let password = this.state.password;
		this.props.authenticateExternalUser(login, password, this.props.isExtranetApp);
	}

	onCaptchaChange(value) {
		if (value.length === 0) {
			this.setState({ captchaOk: false });
			this.props.throwErrorMessage({ message: 'Veuillez vérifier que vous êtes bien un humain' });
		} else {
			this.setState({ captchaOk: true });
		}
	}

	forgotPasswordClick() {
		this.setState({
			forgotPassword: true,
			captchaOk: false
		});
	}

	requestNewPasswordByMail() {
		if (!this.state.captchaOk) {
			this.props.throwErrorMessage({ message: 'Veuillez renseigner le captcha afin de valider le formulaire' });
			return;
		}

		if (!checkEmailFormat(this.state.login)) {
			this.props.throwErrorMessage({
				title: "Erreur",
				message: "L'identifiant doit-être sous forme d'adresse mail",
			})

			return;
		}

		this.props.requestNewPasswordByMail(this.state.login);
		this.setState({ captchaOk: false });
		this.close();
	}

	close() {
		this.setState({ forgotPassword: false })
	}

	render() {
		let h = window.innerHeight > window.innerWidth;
		const { classes } = this.props;

		let paperContainer = {
			height: h ? "100vw" : "75vh",
			width: h ? "75vw" : "75vh",
			margin: h ? "5vw" : "5vh",
			zIndex: 2,
			position: "absolute",
		};

		return (
			<MuiThemeProvider theme={theme}>
				<div className="div-center">
					<div
						style={{
							width: "100%",
							minHeight: "calc(100vh - 80px)",//marge de la menuAppBar 80
							height: "calc(100vh - 80px)",//marge de la menuAppBar 80
							maxHeight: "200vh",
							backgroundSize: "cover",
							backgroundPositionX: "50%",
							overflow: "hidden",
							position: "relative",
						}}
					>
						{h ? (
							<svg
								viewBox="0 0 100 200"
								preserveAspectRatio="xMinYMin meet"
								style={{
									position: "absolute",
									height: "200vw",
									width: "100vw",
									zIndex: 1,
								}}
							>
								<path
									d="M 80 20 L 100 32.5 L 100 153.5 L 20 87.5 Z"
									fill="rgba(100, 100, 100, 0.21)"
								/>
							</svg>
						) : (
								<svg
									viewBox="0 0 200 100"
									preserveAspectRatio="xMinYMin meet"
									style={{
										position: "absolute",
										height: "calc(100vh - 55px)",//marge de la menuAppBar 55
										width: "200vh",
										zIndex: 1,
									}}
								>
									<path
										d="M 83.5 20 L 167.5 100 L 32.5 96 L 20 83.5 Z"
										fill="rgba(100, 100, 100, 0.21)"
									/>
								</svg>
							)}
						<Paper elevation={4} style={paperContainer}>
							<div className="div-center logo-margin-top">
								<img src={logo} alt="logo" style={styles.bgImage} />
							</div>
							<div style={styles.loginContainer} className="row login-container">
								<div className="col-lg-12 col-md-12 col-sm-12 col-12">
									<form onSubmit={this.login.bind(this)} className="col-lg-12 col-md-12 col-sm-12 col-12">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top without-padding">
											<CustomizedTextField
												id="code"
												label="Identifiant"
												className="full_size"
												value={this.state.login}
												onChange={(e) => this.setState({ login: e.target.value })}
												margin="normal"
											/>
										</div>
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top without-padding">
											<TextField
												id="password"
												label="Mot de passe"
												type="password"
												className="full_size"
												value={this.state.password}
												onChange={(e) => {
													if (e.keyCode === 13 /*enter*/) {
														this.login();
													}

													this.setState({ password: e.target.value })
												}}
												margin="normal" />
										</div>
										<Button type="submit"
											className="btn-login col-lg-12 col-md-12 col-sm-12 col-12"
										>Connexion</Button>
										<a onClick={this.forgotPasswordClick.bind(this)} className="element-right" href='#'>Mot de passe oublié?</a>
									</form>
								</div>
							</div>
						</Paper>

					</div>
					<Dialog aria-labelledby="simple-dialog-title" open={this.state.forgotPassword}
						onClose={this.close.bind(this)}>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit" className={classes.flex}>
									{"Mot de passe oublié?"}
								</Typography>
							</Toolbar>
						</AppBar>
						<DialogContent className="without-side-padding">
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
								<Typography variant="inherit">{"En remplissant ce formulaire, un mail sera envoyé à l'adresse correspondant au nom de compte saisi. Suivez les instructions pour pouvoir vous connecter"}</Typography>
								<CustomizedTextField
									id="code"
									label="Identifiant"
									className="full_size"
									value={this.state.login}
									onChange={(e) => this.setState({ login: e.target.value })}
									margin="normal"
								/>
							</div>
							<ReCAPTCHA
								sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_API_KEY}
								onChange={this.onCaptchaChange.bind(this)}
							/>
							<Button
								className="btn-login col-lg-12 col-md-12 col-sm-12 col-12"
								color="primary"
								onClick={this.requestNewPasswordByMail.bind(this)}
							>{"C'est parti !"}</Button>
						</DialogContent>
					</Dialog>
				</div>
			</MuiThemeProvider>
		);
	}
}

// export default withRouter(Login)
const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		isExtranetApp: state.context.isExtranetApp,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		authenticateExternalUser: (login, password, isExtranetApp) =>
			dispatch(authenticateExternalUser(login, password, getSynchroActiveUser, getDefaultSyncState, isExtranetApp)),
		loadActiveUser: () => dispatch(loadActiveUser()),
		requestNewPasswordByMail: (login) => dispatch(requestNewPasswordByMail(login)),
		throwErrorMessage: (errObj) => dispatch(throwErrorMessage(errObj)),
	};
};
export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(KeystoneMyOpenLogin);
